/**
 * Replaces all occurrences of a string in a string
 *
 * @export
 * @param {string} string
 * @param {string} search
 * @param {string} replacement
 * @returns
 */
export function replaceAll (string: string, search: string, replacement: string): string {
  return string
    .split(search)
    .join(replacement)
}

// Do not export this as `capitalize`: Nuxt auto-imports app/utils names and can
// inject a JS import into CSS that contains `text-transform: capitalize`.
export const capitalizeWords = (str: string) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export const isString = (val: unknown): val is string => typeof val === 'string'

/**
 * Converts any value to a string
 * @param value - The value to convert to string
 * @returns String representation of the value
 */
export const toString = (value: string | number | undefined | null): string => {
  if (value === null || value === undefined) {
    return ''
  }
  return String(value)
}

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}

/**
 * Escapes a value for interpolation into an HTML string.
 *
 * Some table cells are built as markup and rendered through `VHtml`, which is a
 * bare `v-html` with no sanitising. Customer-supplied fields (names, addresses)
 * must go through this before being embedded, or a customer record can inject
 * markup into the demonstrator's page.
 */
export const escapeHtml = (value: string | number | null | undefined): string =>
  toString(value as string | number | null | undefined).replace(/[&<>"']/g, char => HTML_ESCAPES[char] ?? char)
